import { getField, updateField } from "vuex-map-fields";

const getDefaultState = () => {
  return {
    includeArchives: false
  };
};

const state = getDefaultState();

const getters = {
  getField
};

const mutations = {
  updateField
};

const actions = {};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
